'use strict';

var _startsWith2 = _interopRequireDefault(require("lodash/startsWith"));

var _each2 = _interopRequireDefault(require("lodash/each"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  pair: function pair(element) {
    var pair;
    (0, _each2.default)(element, function (k, i) {
      if ((0, _startsWith2.default)(i, '$')) {
        pair = [i, element[i]];
      }

      return false;
    });
    return pair;
  },
  pairs: function pairs(element) {
    var pairs = [];
    (0, _each2.default)(element, function (k, i) {
      if ((0, _startsWith2.default)(i, '$')) {
        pairs.push([i, element[i]]);
      } else {
        pairs = [];
        return false;
      }
    });
    return pairs;
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vcGFpci5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwicGFpciIsImVsZW1lbnQiLCJrIiwiaSIsInBhaXJzIiwicHVzaCJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7O0FBSUFBLE9BQU9DLE9BQVAsR0FBaUI7QUFFaEJDLFFBQU0sY0FBVUMsT0FBVixFQUFvQjtBQUV6QixRQUFJRCxJQUFKO0FBRUEsd0JBQVFDLE9BQVIsRUFBaUIsVUFBRUMsQ0FBRixFQUFLQyxDQUFMLEVBQVk7QUFFNUIsVUFBSywwQkFBY0EsQ0FBZCxFQUFpQixHQUFqQixDQUFMLEVBQThCO0FBRTdCSCxlQUFPLENBQUVHLENBQUYsRUFBS0YsUUFBU0UsQ0FBVCxDQUFMLENBQVA7QUFFQTs7QUFFRCxhQUFPLEtBQVA7QUFFQSxLQVZEO0FBWUEsV0FBT0gsSUFBUDtBQUVBLEdBcEJlO0FBc0JoQkksU0FBTyxlQUFVSCxPQUFWLEVBQW9CO0FBRTFCLFFBQUlHLFFBQVEsRUFBWjtBQUVBLHdCQUFRSCxPQUFSLEVBQWlCLFVBQUVDLENBQUYsRUFBS0MsQ0FBTCxFQUFZO0FBRTVCLFVBQUssMEJBQWNBLENBQWQsRUFBaUIsR0FBakIsQ0FBTCxFQUE4QjtBQUU3QkMsY0FBTUMsSUFBTixDQUFZLENBQUVGLENBQUYsRUFBS0YsUUFBU0UsQ0FBVCxDQUFMLENBQVo7QUFFQSxPQUpELE1BSU87QUFFTkMsZ0JBQVEsRUFBUjtBQUNBLGVBQU8sS0FBUDtBQUVBO0FBRUQsS0FiRDtBQWVBLFdBQU9BLEtBQVA7QUFFQTtBQTNDZSxDQUFqQiIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxuaW1wb3J0IF8gZnJvbSAnbG9kYXNoJztcblxubW9kdWxlLmV4cG9ydHMgPSB7XG5cblx0cGFpcjogZnVuY3Rpb24oIGVsZW1lbnQgKSB7XG5cblx0XHR2YXIgcGFpcjtcblxuXHRcdF8uZWFjaCggZWxlbWVudCwgKCBrLCBpICkgPT4ge1xuXG5cdFx0XHRpZiAoIF8uc3RhcnRzV2l0aCggaSwgJyQnICkgKSB7XG5cblx0XHRcdFx0cGFpciA9IFsgaSwgZWxlbWVudFsgaSBdIF07XG5cblx0XHRcdH1cblxuXHRcdFx0cmV0dXJuIGZhbHNlO1xuXG5cdFx0fSApO1xuXG5cdFx0cmV0dXJuIHBhaXI7XG5cblx0fSxcblxuXHRwYWlyczogZnVuY3Rpb24oIGVsZW1lbnQgKSB7XG5cblx0XHR2YXIgcGFpcnMgPSBbXTtcblxuXHRcdF8uZWFjaCggZWxlbWVudCwgKCBrLCBpICkgPT4ge1xuXG5cdFx0XHRpZiAoIF8uc3RhcnRzV2l0aCggaSwgJyQnICkgKSB7XG5cblx0XHRcdFx0cGFpcnMucHVzaCggWyBpLCBlbGVtZW50WyBpIF0gXSApO1xuXG5cdFx0XHR9IGVsc2Uge1xuXG5cdFx0XHRcdHBhaXJzID0gW107XG5cdFx0XHRcdHJldHVybiBmYWxzZTtcblxuXHRcdFx0fVxuXG5cdFx0fSApO1xuXG5cdFx0cmV0dXJuIHBhaXJzO1xuXG5cdH1cblxufTsiXX0=